import React from "react";
import { Grid, Button } from "@sumprio/ui";
import { SafeTooltipTrigger as TooltipTrigger } from "components/common/SafeTooltipTrigger";
import { Edit2Icon, TrashIcon } from "@sumprio/ui/icons";

export interface EditDeleteActionsProps {
  canEdit: boolean;
  editLabel: string;
  editDisabledTooltip: string;
  deleteLabel: string;
  canDelete?: boolean;
  deleteDisabledTooltip?: string;
  onEdit: () => void;
  onDelete: () => void;
}

export default function EditDeleteActions({
  canEdit,
  editLabel,
  editDisabledTooltip,
  deleteLabel,
  canDelete = true,
  deleteDisabledTooltip = "Delete is only available for Not Live items",
  onEdit,
  onDelete,
}: EditDeleteActionsProps) {
  return (
    <Grid display="flex" alignItems="center" gap="xs" flexWrap="nowrap">
      <TooltipTrigger
        tooltip={canEdit ? editLabel : editDisabledTooltip}
        placement="top-end"
        theme="dark"
        minWidth="150px"
        maxWidth="200px"
      >
        <span>
          <Button
            iconOnly
            icon={Edit2Icon}
            variant="brand-tertiaryColor"
            size="xs"
            onClick={() => canEdit && onEdit()}
            disabled={!canEdit}
            aria-label={editLabel}
          />
        </span>
      </TooltipTrigger>
      <TooltipTrigger
        tooltip={canDelete ? deleteLabel : deleteDisabledTooltip}
        placement="top-end"
        theme="dark"
        minWidth="150px"
        maxWidth="200px"
      >
        <span>
          <Button
            iconOnly
            icon={TrashIcon}
            variant="danger-tertiary"
            size="xs"
            onClick={() => canDelete && onDelete()}
            disabled={!canDelete}
            aria-label={deleteLabel}
          />
        </span>
      </TooltipTrigger>
    </Grid>
  );
}
